import { TextField } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface MetadataState {
  appName: string;
  environment: string;
  description: string;
}

export interface RateLimitState {
  requestsPerMinute: string;
  requestsPerDay: string;
}

interface CreateApiKeyMetadataFieldsProps {
  metadata: MetadataState;
  onMetadataChange: (metadata: MetadataState) => void;
  expiresAt: string;
  onExpiresAtChange: (value: string) => void;
  rateLimit: RateLimitState;
  onRateLimitChange: (rateLimit: RateLimitState) => void;
}

export const CreateApiKeyMetadataFields: React.FC<CreateApiKeyMetadataFieldsProps> = ({
  metadata,
  onMetadataChange,
  expiresAt,
  onExpiresAtChange,
  rateLimit,
  onRateLimitChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div>
        <p className="mb-2 text-sm font-semibold text-gray-800 dark:text-slate-200">
          {t('apiKeys.modal.metadata')}{' '}
          <span className="font-normal text-gray-400">{t('apiKeys.modal.optional')}</span>
        </p>

        <TextField
          fullWidth
          label={t('apiKeys.modal.appName')}
          value={metadata.appName}
          onChange={(e) => onMetadataChange({ ...metadata, appName: e.target.value })}
          size="small"
          margin="dense"
          placeholder={t('apiKeys.modal.appNamePlaceholder')}
        />
        <TextField
          fullWidth
          label={t('apiKeys.modal.environment')}
          value={metadata.environment}
          onChange={(e) => onMetadataChange({ ...metadata, environment: e.target.value })}
          size="small"
          margin="dense"
          placeholder={t('apiKeys.modal.environmentPlaceholder')}
        />
        <TextField
          fullWidth
          label={t('apiKeys.modal.description')}
          value={metadata.description}
          onChange={(e) => onMetadataChange({ ...metadata, description: e.target.value })}
          size="small"
          margin="dense"
          multiline
          rows={2}
          placeholder={t('apiKeys.modal.descriptionPlaceholder')}
        />
      </div>

      <div>
        <p className="mb-2 text-sm font-semibold text-gray-800 dark:text-slate-200">
          {t('apiKeys.modal.keyPolicy')}{' '}
          <span className="font-normal text-gray-400">{t('apiKeys.modal.optional')}</span>
        </p>
        <div className="grid gap-3 md:grid-cols-3">
          <TextField
            fullWidth
            label={t('apiKeys.modal.expiresAt')}
            value={expiresAt}
            onChange={(e) => onExpiresAtChange(e.target.value)}
            type="datetime-local"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            label={t('apiKeys.modal.rateLimitMinute')}
            value={rateLimit.requestsPerMinute}
            onChange={(e) => onRateLimitChange({ ...rateLimit, requestsPerMinute: e.target.value })}
            type="number"
            size="small"
            inputProps={{ min: 1 }}
          />
          <TextField
            fullWidth
            label={t('apiKeys.modal.rateLimitDay')}
            value={rateLimit.requestsPerDay}
            onChange={(e) => onRateLimitChange({ ...rateLimit, requestsPerDay: e.target.value })}
            type="number"
            size="small"
            inputProps={{ min: 1 }}
          />
        </div>
      </div>
    </>
  );
};
